module.exports = __webpack_public_path__ + "static/password-reset-280577a2baf202be224b63298239ce64.png";